module.exports = __webpack_public_path__ + "img/Artboard611.8afa59bd.jpg";